import { render, staticRenderFns } from "./Dicability.vue?vue&type=template&id=45fc32f8&scoped=true"
import script from "./Dicability.vue?vue&type=script&lang=js"
export * from "./Dicability.vue?vue&type=script&lang=js"
import style0 from "./Dicability.vue?vue&type=style&index=0&id=45fc32f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc32f8",
  null
  
)

export default component.exports